<template>
  <!-- 能耗排名 ranking-->
  <div class="home" ref="print">
    <!-- 能源区域：
      <span style="margin-right:24px;color:#6071f2;font-size:16px">{{nowBuilding.name}}</span> -->
    <div class="con">
      <div class="search-input-btn">
        <el-scrollbar style="height:100%;width: 100%;">
          <div class="my-search-i">
            <div class="input-small myinput">
              <span>能源类型：</span>
              <el-select
                v-model="energyType"
                placeholder="请选择" 
              >
                <el-option
                  v-for="item in typeOptions"
                  :key="item.appTypeNo"
                  :label="item.typeName"
                  :value="item.appTypeNo"
                >
                </el-option>
              </el-select>
            </div>
            <div class="input-small myinput" style="margin:0px 20px;">
              <span>时间：</span>
              <el-select
                v-model="timeType"
                placeholder="请选择" 
                @change="timeType_fn"
              >
                <el-option label="日" value="DAY"> </el-option>
                <el-option label="月" value="MONTH"> </el-option>
                <el-option label="年" value="YEAR"> </el-option>
              </el-select>
            </div>
            <div class="input-small">
              <el-date-picker
                class="picker"
                v-model="dateValue"
                type="date"
                placeholder="请选择日期"
                v-if="dateType == 'DAY'"
                :picker-options="pickerOptions"
              ></el-date-picker>
              <el-date-picker
                class="picker"
                v-model="dateValue"
                type="month"
                placeholder="请选择月份"
                v-if="dateType == 'MONTH'"
                :picker-options="pickerOptions"
              ></el-date-picker>
              <el-date-picker
                class="picker"
                v-model="dateValue"
                type="year"
                placeholder="请选择年份"
                v-if="dateType == 'YEAR'"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </div>
            <div class="input-small myinput" style="margin-left:20px;">
              <span>顺序：</span>
              <el-select
                v-model="sorts"
                placeholder="请选择" 
                @change="sortsChange_fn"
              >
                <el-option
                  v-for="item in sortData"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <el-button type="primary" plain @click="getList" class="search-btn"
              >查询</el-button
            >
            <el-button
              type="primary"
              size="mini"
              @click="exportList"
              class="search-btn"
              >导出</el-button
            >
            <div class="tab-chart">
              <div
                :class="['tab-item', { active: tabVal == 'mychart' }]"
                @click="tabVal = 'mychart'"
              >
                图表
              </div>
              <div
                :class="['tab-item', { active: tabVal == 'mytable' }]"
                @click="tabVal = 'mytable'"
              >
                表格
              </div>
            </div>
          </div>
        </el-scrollbar>
      </div>

      <!-- echart图  -->
      <div
        class="box_c"
        v-show="tabVal == 'mychart'"
        :style="{ height: this.heights + 'px' }"
      >
        <vchart style="height: 100%;" ref="vchart"></vchart>
      </div>
      <!-- 表格 -->
      <div class="comtent" v-show="tabVal == 'mytable'" id="printCons">
        <el-table
          stripe
          :data="tableData"
          border
          style="width: 100%"
          :height="heights"
        >
          <template slot="empty">
            <span class="noData">
              <img src="@/assets/noData.png" alt="暂无数据" />
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column label="序号" width="60" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-for="(item, index) in columns"
            :key="index"
            :label="item.name"
            align="center"
          >
            <template slot-scope="{ row }">
              <span>{{ row[item.key] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="同期对比" align="center">
            <template slot-scope="{ row }">
              <div
                style="display: flex; align-items: center; justify-content: center;"
              >
                <span>{{ row.beforeTotal }}</span>
                <i
                  v-if="row.beforeTotal != 0"
                  :class="
                    row.beforeTotal > 0 ? 'el-icon-top' : 'el-icon-bottom'
                  "
                  style="margin-left:10px;font-size:18px"
                ></i>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="el-loading-mask" v-show="isMask">
      <div class="el-loading-spinner">
        <svg viewBox="25 25 50 50" class="circular">
          <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
        </svg>
      </div>
    </div>
    <downloadTable ref="downloadTable"></downloadTable>
  </div>
</template>
<script>
// import { GetRankingEnergyAreaAsync, GetRankingEnergyAreaOfParam } from "@/utils/request";
import { getAllEnergyType } from "../../api/energySubType";
import { getAreaRanking } from "../../api/overView";
import Pagination from "../../components/module/Pagination"; // 分页
import vchart from "../../components/module/Charts/chart.vue"; //echart图
import htmlToPdf from "@/vendor/htmlToPdf"; //下载pdf
import downloadTable from "@/components/module/downloadTable/downloadTable.vue";
let idTmr;

export default {
  components: { Pagination, vchart, downloadTable },
  data() {
    return {
      tabVal: "mychart",
      tabPosition: "left",
      heights: Math.round(document.getElementById("app").clientHeight * 0.77), //屏幕高度 - 导航栏高度
      isMask: false, //遮罩层
      timeType: "DAY",
      dateValue: "",
      dateType: "DAY",
      nowArea: {}, //当前区域
      energyType: "",
      typeOptions: [
        {
          appTypeNo: 1,
          typeName: "水",
        },
        {
          appTypeNo: 2,
          typeName: "电",
        },
        {
          appTypeNo: 3,
          typeName: "气",
        },
        {
          appTypeNo: 4,
          typeName: "汽",
        },
      ],
      options: [],
      dayOption: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // Use axis to trigger tooltip
            type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
          },
        },
        toolbox: {
          show: true,
          showTitle: true, // 隐藏默认文字，否则两者位置会重叠
          right: 50,
          feature: {
            magicType: {
              type: ["line", "bar"],
              title: {
                line: "切换为折线图",
                bar: "切换为柱状图",
              },
            },
            saveAsImage: {
              show: true,
              title: "下载图片",
            },
            // dataView: { show: true, readOnly: true, lang: ['', '关闭'] },
          },
          tooltip: {
            // 和 option.tooltip 的配置项相同
            show: false,
            formatter: function(param) {
              return "<div>" + param.title + "</div>"; // 自定义的 DOM 结构
            },
            backgroundColor: "#fff",
            textStyle: {
              fontSize: 12,
            },
            extraCssText: "box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);", // 自定义的 CSS 样式
          },
        },
        grid: {
          top: "10%",
          left: "3%",
          right: "10%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
        },
        yAxis: {
          type: "category",
          data: [],
        },
        series: [],
        // 配置数据视图组件
        dataZoom: [
          {
            type: "slider", // 滑动条型数据视图
            yAxisIndex: 0, // 针对 xAxis 索引为 0 的轴
            start: 0, // 起始位置
            end: 100, // 结束位置
            showDetail: false, // 不显示详细信息
            orient: "vertical", // 垂直方向
          },
        ],
      },
      selectData: {
        //搜索
        EnergyAreas: [],
        RankingDateType: [],
        RankingOrderByType: [],
      },
      sorts: 1,
      sortData: [
        {
          id: 1,
          name: "升序",
        },
        {
          id: 2,
          name: "降序",
        },
      ],
      total: 100,
      listData: {
        page: 1,
        Rows: 5,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      conditions: {
        type: [],
        Eventtime: new Date(),
      }, //搜索条件
      tableData: [],

      optionsd: [],
      selectedArray: "",
      defaultProps: {
        label: "Name",
        value: "Id",
        checkStrictly: true,
      },
      pageIndex: 1, //当前页
      pageLen: 20, //m
      columns: [
        {
          name: "区域",
          key: "areaName",
        },
        {
          name: "用电量",
          key: "thisTotal",
        },
      ],
      timerDate: 0,
      zhengList: [],
      fanList: [],
      zhengName: [],
      fanName: [],
      mycolorArr: [],
      // colorArr: ['#F56C6C','#67C23A','#409EFF','#E6A23C','#909399']
    };
  },
  filters: {
    type_fn: function(a, t) {
      var d = "";
      t.forEach((v) => {
        if (v.No == a) {
          d = v.Name;
          return v;
        }
      });
      return d;
    },
  },
  //利用计算属性
  computed: {
    nowBuilding() {
      //当前建筑
      return this.$store.cacheStore.state.setBuilding;
    },
  },
  //监听执行
  watch: {
    nowBuilding(val) {
      this.nowArea = val;
      //  this.temp_fn(this.timerType)
    },
    energyType(val) {
      if (val == 36) {
        this.columns[1].name = "用电量(KW·h)";
      } else if (val == 237) {
        this.columns[1].name = "用水量(t)";
      } else if (val == 361) {
        this.columns[1].name = "用气量(m³)";
      }
    },
  },

  mounted() {
    this.$refs.vchart.setData(this.dayOption, true);
    this.nowArea = this.$store.cacheStore.state.setBuilding;

    var date = new Date();
    var str =
      date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
    var today = new Date(str);
    this.dateValue = today;
    this.timerDate = 0;
    this.timerDate += 1;
    this.getList();
  },
  methods: {
    //时间类型变化
    timeType_fn(val) {
      this.dateType = val;
      this.dateValue = "";
    },
    //获取能源类型
    getAllEnergyTypeFun() {},
    color16() {
      //十六进制颜色随机
      var r = Math.floor(Math.random() * 256);
      var g = Math.floor(Math.random() * 256);
      var b = Math.floor(Math.random() * 256);
      var color = "#" + r.toString(16) + g.toString(16) + b.toString(16);
      if (color.length != 7) {
        this.color16();
      } else {
        var myIndex = "";
        myIndex = this.mycolorArr.findIndex((item) => item == color);
        if (myIndex == -1) {
          this.mycolorArr.push(color);
        } else {
          this.color16();
        }
      }
    },

    oldexportList() {
      import("@/vendor/Export2Excel").then((excel) => {
        const tHeader = [];
        const filterVal = [];
        for (const key in this.columns) {
          if (Object.hasOwnProperty.call(this.columns, key)) {
            tHeader.push(this.columns[key].name);
            filterVal.push(this.columns[key].key);
          }
        }

        const list = this.tableData;
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "能耗排名",
          autoWidth: true,
          bookType: "xlsx",
        });
      });
    },
    // 下载excel
    exportList() {
      let time = new Date();
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      var type = this.typeOptions.filter(
        (item) => item.appTypeNo == this.energyType
      );
      var timeType = "";
      if (this.timeType == "DAY") {
        timeType = "日";
      } else if (this.timeType == "MONTH") {
        timeType = "月";
      } else {
        timeType = "年";
      }
      const tHeader = [
        "能源区域",
        this.nowBuilding.name,
        "能源类型",
        type[0].typeName,
        "周期",
        timeType,
        "查询时间",
        this.date_format_fn(this.dateValue),
        "排序方式",
        this.sorts == 1 ? "升序" : "降序",
      ];
      this.$refs.downloadTable.export2Excel(
        tHeader,
        this.tableData,
        year + "-" + month + "-" + day + "-能耗排名",
        "#printCons"
      );
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },
    handleCommand(v) {
      if (v == "Printing") {
        setTimeout(() => {
          this.$nextTick(() => {
            htmlToPdf.download("app", "能耗排名");
          });
        }, 200);
      }
      if (v == "excel") {
        this.exportList();
      }
      if (v == "pdf") {
        htmlToPdf.download("printCons", "能耗排名");
      }
    },
    //获取列表数据
    getList() {
      var res = {
        code: 200,
        message: "操作成功",
        data: [
          {
            areaName: "一号区域",
            thisTotal: 6050.0,
            beforeTotal: -0.12,
          },
          {
            areaName: "二号区域",
            thisTotal: 5052.0,
            beforeTotal: -0.2,
          },
          {
            areaName: "三号区域",
            thisTotal: 4053.0,
            beforeTotal: 12,
          },
          {
            areaName: "四号区域",
            thisTotal: 3053.0,
            beforeTotal: 12,
          },
        ],
      };

      if (res.code == 200) {
        this.timerDate = 0;
        this.tableData = res.data;
        this.dayOption.yAxis.data = [];
        this.dayOption.series = [
          {
            type: "bar",
            data: [],
            barMaxWidth: 30,
          },
        ];
        this.zhengName = [];
        this.fanName = [];
        this.zhengList = [];
        var zhengIndex = this.tableData.length;
        this.mycolorArr = [];
        for (let i = 0; i < zhengIndex; i++) {
          this.color16();
        }
        for (let i = 0; i < zhengIndex; i++) {
          this.zhengList.push({
            value: this.tableData[i].thisTotal,
            itemStyle: {
              color: this.mycolorArr[i],
            },
          });
          this.zhengName.push(this.tableData[i].areaName);
        }
        this.fanName = JSON.parse(JSON.stringify(this.zhengName.reverse()));
        this.fanList = JSON.parse(JSON.stringify(this.zhengList.reverse()));
        this.dayOption.yAxis.data = this.fanName;
        this.dayOption.series[0].data = this.fanList;
        this.$refs.vchart.setData(this.dayOption, true);
        console.log(this.dayOption, "this.dayOption");
        this.isMask = false;
      } else {
        this.isMask = false;
        this.$message.error(`获取失败，${res.message}`);
      }
    },

    //正序反序
    sortsChange_fn(val) {
      this.tableData.reverse();
      this.dayOption.yAxis.data.reverse();
      this.dayOption.series[0].data.reverse();
      this.$refs.vchart.setData(this.dayOption, true);
    },
    // 时间戳转换
    // 转换时间戳
    date_format_fn(value) {
      if (!value) {
        return "";
      }
      let date = new Date(value);
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";

      let h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      let m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      let s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      let strDate = Y + M + D + h + m + s;
      return `'${strDate}'`;
    },
  },
};
</script>

<style lang="scss" scoped>
// .my-search-i {
//    height: 38px !important;
// }
.con {
  width: 100%;
  height: 100%;
  padding: 2px 20px 12px 20px;
  box-sizing: border-box;
  background-color: #fff;
}

.tab-chart {
  width: 130px;
  margin-left: 20px;
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  height: 32px;
  border-radius: 2px;

  // overflow: hidden;
  .tab-item {
    width: 65px;
    height: 100%;
    text-align: center;
    line-height: 34px;
    cursor: pointer;

    &.active {
      background-color: #358ed9;
      color: #fff;
    }
  }
}

.el-icon-top {
  color: #4cb546;
  font-weight: bold;
  position: relative;
  top: -2px;
}

.el-icon-bottom {
  color: #ff8522;
  font-weight: bold;
  position: relative;
  top: -2px;
}

#printCons {
  display: block;
  padding: 10px;
  background-color: #fff;
}

.home {
  background-color: #eceef2;
  padding: 10px;
  position: relative;
}

#app {
  margin-top: 20px;
}

.box_c {
  width: 100%;
  margin-bottom: 15px;
}

.el-icon-d-arrow-left {
  position: absolute;
  right: 0;
  top: 300px;
  z-index: 1;
  font-size: 28px;
  cursor: pointer;
  background: #d7d7d7;
  clip-path: polygon(
    -18px 35px,
    26px 100%,
    calc(100% - 1px) 100%,
    calc(100% - 0px) 0
  );
  height: 70px;
  line-height: 70px;
  color: #666;
}

.el-icon-d-arrow-right {
  position: absolute;
  left: 0;
  top: 300px;
  z-index: 1;
  font-size: 28px;
  cursor: pointer;
  background: #d7d7d7;
  clip-path: polygon(
    0 0,
    1px 100%,
    calc(100% - 26px) 100%,
    calc(100% - -27px) 31px
  );
  height: 70px;
  line-height: 70px;
  color: #666;
}

.pagination_box {
  display: flex;
  justify-content: flex-end;
  margin-top: 5px;
}
</style>
